export const formatStat = (value, field) => {
    if (value === null || value === undefined || value === "")
        return "";
    const rawNumVal = Number(value);
    if (isNaN(rawNumVal))
        return String(value);
    // 🔥 GLOBAL: remove minus sign everywhere
    const numVal = Math.abs(rawNumVal);
    const f = field.toLowerCase().trim();
    // Currency fields
    const currencyFields = [
        "revenue",
        "spend",
        "cpc",
        "aov",
        "gross_sales",
        "discount",
        "google_cost",
        "meta_cost",
        "total_cost",
        "cost_per_session",
        "cpoc",
        "discounts",
        "cpa",
        "cpm",
        "cac",
        "shipping",
        "taxes",
        "tax",
        "refunds",
        "net_sales",
        "gross_revenue",
        "net_revenue",
        "ad_spend",
        "amount",
        "order_value",
        "sales",
        "value",
        "cost",
        "total_revenue",
        "total_sales"
    ];
    if (currencyFields.includes(f)) {
        return `$${numVal.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    }
    // Count fields
    const countFields = [
        "orders",
        "impressions",
        "clicks",
        "sessions",
        "recipients",
        "num_emails",
        "outbound_clicks",
        "outbound_click",
        "outboundclicks",
        "new_user",
        "new_users",
        "total_recipients",
        "unique_placed_order",
        "unique_opens",
        "unique_clicks",
        "no_of_emails",
        "no_of_sms",
        "no_of_flows",
        "unique_place_order",
        "purchases",
        "leads",
        "conversions"
    ];
    if (countFields.includes(f) || f === "number") {
        return numVal.toLocaleString("en-US", {
            maximumFractionDigits: 0,
        });
    }
    // Percentage fields
    const percentageFields = [
        "ctr",
        "cvr",
        "meta_percent",
        "conv_rate",
        "discount_percent",
        "open_rate",
        "click_rate",
        "percent_of_spend",
        "percent_of_sale",
        "bounce_rate",
        "place_rate",
        "place_order_rate",
        "unsubscribe_rate",
        "discount_per",
        "octr",
        "margin",
        "profit_margin",
        "engagement_rate"
    ];
    if (percentageFields.includes(f)) {
        return `${numVal.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}%`;
    }
    // Default numeric
    return numVal.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};
